<jqxWindow #viewShowReferenceLayer id="viewShowReferenceLayer" [width]="320" [height]="300" [resizable]="false" [isModal]="true" [autoOpen]="false" [zIndex]="15000" [modalOpacity]="'0.5'">
  <div #windowHeader>
    <span id="captureContainer" style="float: left">Select Reference Layers</span>
  </div>
  <div #windowContent style="overflow: hidden;">
    <jqxTreeGrid #referenceLayerTree (onRowCheck)="referenceLayerTreeCheckChange($event)"  (onRowUncheck)="referenceLayerTreeCheckChange($event)" id="ReferenceLayerTree" style="" [source]="records" [width]="'99%'" [height]="'99%'" [altRows]="true" [columns]="columns" [checkboxes]="true" [showHeader]="false" [incrementalSearch]="true"> </jqxTreeGrid>
  </div>
</jqxWindow>
